import { UserWalletLedgersQuery } from "../../../../__generated__/graphql";
import LedgerItem from "./ledger-item";

type WalletLedgerItem = UserWalletLedgersQuery["userWalletLedgers"][number];

interface LedgerGroupProps {
  yearMonth: string;
  ledgers: WalletLedgerItem[];
}

const LedgerGroup: React.FC<LedgerGroupProps> = ({ yearMonth, ledgers }) => {
  return (
    <div className="w-full">
      {/* 그룹 헤더 */}
      <div className="px-4 py-3">
        <div className="font-bold text-lg">{yearMonth}</div>
        <div className="border-b border-gray-200 mt-2"></div>
      </div>

      {/* 항목 리스트 */}
      <div className="w-full">
        {ledgers.map((ledger) => (
          <LedgerItem key={ledger.id} ledger={ledger} />
        ))}
      </div>
    </div>
  );
};

export default LedgerGroup;
